export function onImageError(event) {
    // event.target.src = 'http://172.233.151.241:3000/uploads/cat_example_1728697560987.webp';
    // event.target.src = 'https://images.unsplash.com/photo-1584395630827-860eee694d7b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDF8fGVtcHR5JTIwY29udGVudHxlbnwwfHx8fDE2MzY2Njk4NzA&ixlib=rb-1.2.1&q=80&w=400'; // Unsplash image
    // event.target.src = 'https://via.placeholder.com/150?text=No+Image'; // Placeholder image
    event.target.src = require('@/assets/map-icon-park-selected.png');
}


export function getFullImageURL(image_path) {

    if (!image_path) {
        return require('@/assets/map-icon-park-selected.png');
    }

    return process.env.VUE_APP_IMAGE_BASE_URL + image_path;

}


export function formatDateToCustom(date) {
    // Ensure input is a Date object
    if (!(date instanceof Date)) {
        throw new Error("Input must be a valid Date object");
    }

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Return formatted date
    return `${year}.${month}.${day}`;
}

export function formatISODateToCustom(isoDate) {
    // Parse the ISO date string to a Date object
    const date = new Date(isoDate);

    // Validate if the input is a valid Date object
    if (isNaN(date.getTime())) {
        throw new Error("Invalid date format. Please provide a valid ISO date string.");
    }

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Return the formatted date
    return `${year}.${month}.${day}`;
}

export function getPaymentMethod(parking) {
     
    if(parking.payment_method) {
        return parking.payment_method.replace('#$%', ',');

    }
    else {
        return "　";
    }
}


/**
 * 取出可顯示的臨停費率文字（以 temp_description 為準）。
 *
 * 三道條件都通過才會有內容，任一不符即回傳空陣列（呼叫端據此整區不顯示）：
 *   1. 功能開關 VUE_APP_SHOW_TEMP_RATE 為 'true'（預設關閉）
 *   2. 該場站啟用臨停 is_temp = 1
 *   3. temp_description 有填寫內容
 *
 * 為什麼不用 temp_base / temp_day / temp_whole 這些數值欄位：
 * 全部 247 個場站中有 38 個帶數值，但只有 3 種組合、其中 34 個完全相同
 * （50/60/100/300/70/200/80/250），顯示為預設範本值而非各場站實際費率。
 * 例如長春場實際為「平日每小時60元」，數值欄位卻是基本費 50 元、日間 70 元。
 * 直接採用會顯示錯誤價格，因此一律以人工填寫的 temp_description 為準。
 *
 * 回傳陣列，每個元素為一行（description 內的換行會拆成多行）。
 */
export function getTempRates(parking) {

    if (process.env.VUE_APP_SHOW_TEMP_RATE !== 'true') return [];
    if (!parking || Number(parking.is_temp) !== 1) return [];

    const desc = parking.temp_description;
    if (!desc || String(desc).trim() === '') return [];

    return String(desc)
        .split(/\r?\n/)
        .map(function (line) { return line.trim(); })
        .filter(function (line) { return line !== ''; });
}

/**
 * 取出可顯示的剩餘車位資訊。
 *
 * 條件全部通過才回傳物件，否則回傳 null（呼叫端據此整區不顯示）：
 *   1. 功能開關 VUE_APP_SHOW_REMAIN_SPACE 為 'true'（預設關閉）
 *   2. 該場站啟用 is_remain = 1
 *   3. remain_space 有值、remain_total > 0
 *   4. 資料未過期
 *
 * 車位是時效性資料，來源每 15 分鐘更新一次。若來源系統停止更新，
 * 舊數字比沒有數字更容易誤導客人，因此超過期限一律不顯示。
 */
export function getRemainSpace(parking) {

    if (process.env.VUE_APP_SHOW_REMAIN_SPACE !== 'true') return null;
    if (!parking || Number(parking.is_remain) !== 1) return null;

    const remain = parking.remain_space;
    const total = parking.remain_total;
    if (remain === null || remain === undefined || remain === '') return null;
    if (!total || Number(total) <= 0) return null;

    const maxAgeMinutes = Number(process.env.VUE_APP_REMAIN_MAX_AGE_MIN || 120);
    let updatedText = '';
    if (parking.remain_updated_at) {
        // 來源 LogTime 已是本地時間，但後端序列化 DATETIME 時會補上 Z（UTC 標記），
        // 直接解析會再加 8 小時（18:15 變成隔日 02:15）。去掉 Z 以本地時間解讀。
        const raw = String(parking.remain_updated_at)
            .replace(' ', 'T')
            .replace(/(\.\d+)?Z$/, '');
        const t = new Date(raw);
        if (!isNaN(t.getTime())) {
            const ageMin = (Date.now() - t.getTime()) / 60000;
            if (ageMin > maxAgeMinutes) return null;      // 過期不顯示
            const hh = String(t.getHours()).padStart(2, '0');
            const mm = String(t.getMinutes()).padStart(2, '0');
            updatedText = hh + ':' + mm;
        }
    }

    const n = Number(remain);
    const t = Number(total);
    const ratio = t > 0 ? n / t : 0;

    // 空位比例對應號誌燈：50% 以上綠、10% 以上黃、10% 以下紅
    let level = 'red';
    if (ratio >= 0.5) {
        level = 'green';
    } else if (ratio >= 0.1) {
        level = 'yellow';
    }

    // 對外顯示固定級距，不用實際百分比：
    // 精確數字每 15 分鐘就變動一次（79% → 76% → 81%），對客人沒有額外意義，
    // 反而顯得數字在跳動；改以級距呈現，也不揭露實際車位數。
    const LEVEL_TEXT = {
        green: '50% 以上',
        yellow: '10% 以上',
        red: '10% 以下',
    };

    // 後台可逐場站改為顯示實際車位數（is_remain_actual），供停車位少、
    // 級距顯示失真的場站使用（例如共 8 位時「10% 以下」不如「剩 1 位」明確）。
    const useActual = Number(parking.is_remain_actual) === 1;

    return {
        remain: n,
        total: t,
        ratio: ratio,
        level: level,
        levelText: LEVEL_TEXT[level],
        useActual: useActual,
        // 卡片與 marker 提示共用，兩處文字才不會不一致
        displayText: useActual ? (n + ' 位') : LEVEL_TEXT[level],
        updatedText: updatedText,
    };
}

export function paddingBlank(strr) {
     
    if(strr) {
        return strr.replace('#$%', ',');

    }
    else {
        return "　";
    }
}

export function getParkingType(parking) {
    // console.log('getParkingType:', parking);

    const is_street = parking.is_street
    const is_tower = parking.is_tower
    const is_underground = parking.is_underground
    const is_garage = parking.is_garage

    const parking_types = []
    if (is_street) parking_types.push('平面停車場')
    if (is_tower) parking_types.push('機械車塔')
    if (is_underground) parking_types.push('地下停車場')
    if (is_garage) parking_types.push('立體停車場')


    // return is_street ? '平面停車' : is_tower ? '停車塔' : is_underground ? '地下停車' : '其他'
    return parking_types

    // return parking.type === '停車塔' ? '停車塔' : '平面停車';
}

// src/util/util.js

export function getCountyDistrictDict() {
    const county_district_dict = {
        'counties': [
            '台北市', '基隆市', '新北市', '宜蘭縣', '桃園市', '新竹市',
            '新竹縣', '苗栗縣', '台中市', '彰化縣', '南投縣',
            '嘉義市', '嘉義縣', '雲林縣', '台南市', '高雄市',
            '澎湖縣', '金門縣', '屏東縣', '台東縣', '花蓮縣', '連江縣'
        ],
        'districts': {
            '台北市': [
                '中正區', '大同區', '中山區', '松山區',
                '大安區', '萬華區', '信義區', '士林區',
                '北投區', '內湖區', '南港區', '文山區'
            ],
            '基隆市': [
                '仁愛區', '信義區', '中正區', '中山區',
                '安樂區', '暖暖區', '七堵區'
            ],
            '新北市': [
                '萬里區', '金山區', '板橋區', '汐止區',
                '深坑區', '石碇區', '瑞芳區', '平溪區',
                '雙溪區', '貢寮區', '新店區', '坪林區',
                '烏來區', '永和區', '中和區', '土城區',
                '三峽區', '樹林區', '鶯歌區', '三重區',
                '新莊區', '泰山區', '林口區', '蘆洲區',
                '五股區', '八里區', '淡水區', '三芝區', '石門區'
            ],
            '宜蘭縣': [
                '宜蘭市', '頭城鎮', '礁溪鄉', '壯圍鄉',
                '員山鄉', '羅東鎮', '三星鄉', '大同鄉',
                '五結鄉', '冬山鄉', '蘇澳鎮', '南澳鄉', '釣魚台列嶼'
            ],
            '桃園市': [
                '中壢區', '平鎮區', '龍潭區', '楊梅區',
                '新屋區', '觀音區', '桃園區', '龜山區',
                '八德區', '大溪區', '復興區', '大園區', '蘆竹區'
            ],
            '新竹市': ['東區', '北區', '香山區'],
            '新竹縣': [
                '竹北市', '湖口鄉', '新豐鄉', '新埔鎮',
                '關西鎮', '芎林鄉', '寶山鄉', '竹東鎮',
                '五峰鄉', '橫山鄉', '尖石鄉', '北埔鄉', '峨眉鄉'
            ],
            '苗栗縣': [
                '竹南鎮', '頭份市', '三灣鄉', '南庄鄉',
                '獅潭鄉', '後龍鎮', '通霄鎮', '苑裡鎮',
                '苗栗市', '造橋鄉', '頭屋鄉', '公館鄉',
                '大湖鄉', '泰安鄉', '銅鑼鄉', '三義鄉',
                '西湖鄉', '卓蘭鎮'
            ],
            '台中市': [
                '中區', '東區', '南區', '西區', '北區',
                '北屯區', '西屯區', '南屯區', '太平區',
                '大里區', '霧峰區', '烏日區', '豐原區',
                '后里區', '石岡區', '東勢區', '和平區',
                '新社區', '潭子區', '大雅區', '神岡區',
                '大肚區', '沙鹿區', '龍井區', '梧棲區',
                '清水區', '大甲區', '外埔區', '大安區'
            ],
            '彰化縣': [
                '彰化市', '芬園鄉', '花壇鄉', '秀水鄉',
                '鹿港鎮', '福興鄉', '線西鄉', '和美鎮',
                '伸港鄉', '員林市', '社頭鄉', '永靖鄉',
                '埔心鄉', '溪湖鎮', '大村鄉', '埔鹽鄉',
                '田中鎮', '北斗鎮', '田尾鄉', '埤頭鄉',
                '溪州鄉', '竹塘鄉', '二林鎮', '大城鄉',
                '芳苑鄉', '二水鄉'
            ],
            '南投縣': [
                '南投市', '中寮鄉', '草屯鎮', '國姓鄉',
                '埔里鎮', '仁愛鄉', '名間鄉', '集集鎮',
                '水里鄉', '魚池鄉', '信義鄉', '竹山鎮', '鹿谷鄉'
            ],
            '嘉義市': ['東區', '西區'],
            '嘉義縣': [
                '番路鄉', '梅山鄉', '竹崎鄉', '阿里山',
                '中埔鄉', '大埔鄉', '水上鄉', '鹿草鄉',
                '太保市', '朴子市', '東石鄉', '六腳鄉',
                '新港鄉', '民雄鄉', '大林鎮', '溪口鄉',
                '義竹鄉', '布袋鎮'
            ],
            '雲林縣': [
                '斗南鎮', '大埤鄉', '虎尾鎮', '土庫鎮',
                '褒忠鄉', '東勢鄉', '台西鄉', '崙背鄉',
                '麥寮鄉', '斗六市', '林內鄉', '古坑鄉',
                '莿桐鄉', '西螺鎮', '二崙鄉', '北港鎮',
                '水林鄉', '口湖鄉', '四湖鄉', '元長鄉'
            ],
            '台南市': [
                '中西區', '東區', '南區', '北區',
                '安平區', '安南區', '永康區', '歸仁區',
                '新化區', '左鎮區', '玉井區', '楠西區',
                '南化區', '仁德區', '關廟區', '龍崎區',
                '官田區', '麻豆區', '佳里區', '西港區',
                '七股區', '將軍區', '學甲區', '北門區',
                '新營區', '後壁區', '白河區', '東山區',
                '六甲區', '下營區', '柳營區', '鹽水區',
                '善化區', '大內區', '山上區', '新市區', '安定區'
            ],
            '高雄市': [
                '新興區', '前金區', '苓雅區', '鹽埕區',
                '鼓山區', '旗津區', '前鎮區', '三民區',
                '楠梓區', '小港區', '左營區', '仁武區',
                '大社區', '東沙群島', '南沙群島', '岡山區',
                '路竹區', '阿蓮區', '田寮區', '燕巢區',
                '橋頭區', '梓官區', '彌陀區', '永安區',
                '湖內區', '鳳山區', '大寮區', '林園區',
                '鳥松區', '大樹區', '旗山區', '美濃區',
                '六龜區', '內門區', '杉林區', '甲仙區',
                '桃源區', '那瑪夏區', '茂林區', '茄萣區'
            ],
            '澎湖縣': ['馬公市', '西嶼鄉', '望安鄉', '七美鄉', '白沙鄉', '湖西鄉'],
            '金門縣': ['金沙鎮', '金湖鎮', '金寧鄉', '金城鎮', '烈嶼鄉', '烏坵鄉'],
            '屏東縣': [
                '屏東市', '三地門鄉', '霧台鄉', '瑪家鄉',
                '九如鄉', '里港鄉', '高樹鄉', '鹽埔鄉',
                '長治鄉', '麟洛鄉', '竹田鄉', '內埔鄉',
                '萬丹鄉', '潮州鎮', '泰武鄉', '來義鄉',
                '萬巒鄉', '崁頂鄉', '新埤鄉', '南州鄉',
                '林邊鄉', '東港鎮', '琉球鄉', '佳冬鄉',
                '新園鄉', '枋寮鄉', '枋山鄉', '春日鄉',
                '獅子鄉', '車城鄉', '牡丹鄉', '恆春鎮', '滿州鄉'
            ],
            '台東縣': [
                '台東市', '綠島鄉', '蘭嶼鄉', '延平鄉',
                '卑南鄉', '鹿野鄉', '關山鎮', '海端鄉',
                '池上鄉', '東河鄉', '成功鎮', '長濱鄉',
                '太麻里', '金峰鄉', '大武鄉', '達仁鄉'
            ],
            '花蓮縣': [
                '花蓮市', '新城鄉', '秀林鄉', '吉安鄉',
                '壽豐鄉', '鳳林鎮', '光復鄉', '豐濱鄉',
                '瑞穗鄉', '萬榮鄉', '玉里鎮', '卓溪鄉', '富里鄉'
            ],
            '連江縣': ['南竿鄉', '北竿鄉', '莒光鄉', '東引鄉']
        }
    };

    return county_district_dict;
}
/* global google */
export function createCustomMarkerIcon(name, isSelected, isMobile=false) {
    console.log('createCustomMarkerIcon:', name, isSelected);
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const scale = 3; // Scale factor
        
        const iconSize = 28 * scale;    // Final displayed icon size
        const iconPadding = 8 * scale; // Padding around the image inside the green rectangle
        const iconCornerRadius = 6 * scale; // Rounded corner radius for the icon

        const fontSize = 16 * scale;    // Font size
        const gap = 6 * scale;          // Gap between icon and text
        const vpadding = 6 * scale;     // Vertical padding for text
        const hpadding = 5 * scale;     // Horizontal padding for text
        const cornerRadius = 7 * scale; // Rounded corner radius

        // Predefined crop size (non-square dimensions)
        // For example, we choose a wide rectangular region
        const cropWidth = 132;
        const cropHeight = 120;

        const ctx = canvas.getContext('2d');
        
        // Set the font before measuring text
        ctx.font = `${fontSize}px Inter`;

        // Measure text width with padding
        const textWidth = ctx.measureText(name).width + 2 * hpadding; 
        const textHeight = fontSize + 2 * vpadding;

        const paddedIconSize = iconSize + 2 * iconPadding;
        const canvasWidth = Math.max(paddedIconSize, textWidth);
        const canvasHeight = paddedIconSize + gap + textHeight;

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        // After resizing the canvas, re-set font and properties
        ctx.font = `${fontSize}px Inter`;
        // use bold font for selected icon
        ctx.font =  `bold ${ctx.font}` ;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.imageSmoothingEnabled = false;

        const img = new Image();
        img.src = require('@/assets/map-icon-park-selected.png'); // Your icon image
        // img.src = require('@/assets/MapIcon.svg'); // Your icon image

        img.onload = () => {
            if (img.width === 0 || img.height === 0) {
                console.warn('Icon image loaded but has zero width/height.');
            }

            // Calculate positions
            const iconX = (canvasWidth - iconSize) / 2;
            const iconY = iconPadding; 
            const textBarY = paddedIconSize + gap; 

            // Draw the green rectangle around the icon area first
            ctx.fillStyle = '#008842';

            if (!isSelected) {
                // Draw the red rectangle around the text area for selected icons
                drawRoundedRectHalfColors(
                    ctx,
                    iconX - iconPadding,
                    iconY - iconPadding,
                    iconSize + iconPadding * 2,
                    iconSize + iconPadding * 2,
                    iconCornerRadius
                );
    

            } else {

                ctx.fillStyle = '#008842';
                drawRoundedRect(
                    ctx,
                    iconX - iconPadding,
                    iconY - iconPadding,
                    iconSize + iconPadding * 2,
                    iconSize + iconPadding * 2,
                    iconCornerRadius
                );
                ctx.fill();
            }

            // Compute center crop source coordinates
            const sx = Math.max(0, (img.width - cropWidth) / 2);
            const sy = Math.max(0, (img.height - cropHeight) / 2);
            const sWidth = Math.min(cropWidth, img.width);
            const sHeight = Math.min(cropHeight, img.height);

            // Draw the cropped portion of the image, scaled to fit the iconSize
            ctx.drawImage(img, sx, sy, sWidth, sHeight, iconX, iconY, iconSize, iconSize);

            // Draw the rectangle background for the text
            ctx.fillStyle =  '#01582F'; 
            drawRoundedRect(
                ctx,
                (canvasWidth - textWidth) / 2,
                textBarY,
                textWidth,
                textHeight,
                cornerRadius
            );
            ctx.fill();

            // Draw the text
            ctx.fillStyle = 'white'; 
            const textX = canvasWidth / 2;
            const textY = textBarY + textHeight / 2 + 3; 
            ctx.fillText(name, textX, textY);

            
            let oscaledWidth = canvasWidth / scale
            let oscaledHeight = canvasHeight / scale

            // let oscaledSize = new google.maps.Size(canvasWidth / scale, canvasHeight / scale)
            if (isSelected) {
                //108x108 icon
                // oscaledSize = new google.maps.Size(canvasWidth*1.5 / scale, canvasHeight*1.5 / scale)
                oscaledWidth = canvasWidth*1.5 / scale
                oscaledHeight = canvasHeight*1.5 / scale

            }

            if (isMobile) {
                console.log('isMobile:', isMobile);
                // oscaledSize = new google.maps.Size(canvasWidth / scale, canvasHeight / scale)
                oscaledWidth = oscaledWidth*0.6;
                oscaledHeight = oscaledHeight*0.6;
            }

            const oscaledSize = new google.maps.Size(oscaledWidth, oscaledHeight)

            // Create the icon object
            const icon = {
                url: canvas.toDataURL(),
                scaledSize: oscaledSize,
            };

            resolve(icon);
        };

        img.onerror = (err) => {
            console.error('Error loading icon image:', err);
            reject(err);
        };
    });
}


/**
 * Draws a rounded rectangle with the upper half in white and the lower half in green.
 * You must call ctx.fill() or ctx.stroke() after calling this function.
 */
function drawRoundedRectHalfColors(ctx, x, y, width, height, radius) {
    // Begin a new path for the rounded rectangle
    drawRoundedRect(ctx, x, y, width, height, radius);

    // Create a linear gradient that goes from top to bottom of the rectangle
    const gradient = ctx.createLinearGradient(0, y, 0, y + height);

    // Add color stops:
    // - White from the top to the midpoint
    // - Green from the midpoint to the bottom
    gradient.addColorStop(0, 'white');
    gradient.addColorStop(0.5, 'white'); // Midpoint
    gradient.addColorStop(0.5, 'green');
    gradient.addColorStop(1, 'green');

    // Set the fill style to the created gradient
    ctx.fillStyle = gradient;

    // Fill the rounded rectangle with the gradient
    ctx.fill();
}


/**
 * Draws a rectangle path with rounded corners.
 * You must call ctx.fill() or ctx.stroke() after calling this function.
 */
function drawRoundedRect(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
}


/**
 * 官網點擊行為記錄：寫入 165 web-app-db.api_logs（經 refund_logger 的通用 /log 端點）。
 * best-effort：不 await、失敗只記 console，絕不影響操作流程。
 * event: 'web_parking_click'（點停車場）| 'web_rate_click'（月租牌價）| 'web_nav_click'（導航）
 */
export function logWebClick(event, parking, extra) {
    if (!parking) return;
    sendClickLog(event, Object.assign({
        parking_id: parking.parking_id || '',
        title: parking.title || '',
    }, extra || {}));
}


/**
 * 最新消息點擊記錄（api_name: web_news_click），與 logWebClick 同一條管道。
 * source: 'banner'（首頁頂端清單）| 'home'（首頁最新消息區）| 'all'（所有最新消息頁）
 */
export function logNewsClick(news, source) {
    if (!news) return;
    sendClickLog('web_news_click', {
        news_id: news.id,
        title: news.title || '',
        source: source || '',
    });
}


function sendClickLog(event, requestData) {
    const base = process.env.VUE_APP_CLICK_LOG_API_URL;
    if (!base) return;
    const payload = {
        api_name: event,
        method: 'CLICK',
        url: window.location.href,
        request_data: requestData,
    };
    try {
        // keepalive：換頁/開新分頁時請求仍能送完
        fetch(`${base}/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
        }).catch((e) => console.warn('click log 失敗（不影響操作）:', e));
    } catch (e) {
        console.warn('click log 失敗（不影響操作）:', e);
    }
}


/**
 * 通用 API 請求／回應記錄：寫入 165 web-app-db.api_logs（經 /wren 的 /log 端點）。
 * best-effort：不 await、失敗只記 console，絕不影響原本流程。
 * entry: { api_name, method, url, request_data, response_data, status_code, error_message }
 */
export function logApi(entry) {
    const base = process.env.VUE_APP_REFUND_LOG_API_URL;
    if (!base) return;
    try {
        fetch(`${base}/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(entry),
            keepalive: true,
        }).catch((e) => console.warn('api log 失敗（不影響流程）:', e));
    } catch (e) {
        console.warn('api log 失敗（不影響流程）:', e);
    }
}


/**
 * 信用卡卡號遮碼：只保留前六碼與末四碼，中間一律以 * 取代，再每四碼一組顯示。
 * 例：4123456789012345 → 「4123 45** **** 2345」
 *
 * 前六碼（BIN）＋末四碼是 PCI DSS 允許顯示的上限，不得再多。
 * 位數不足 11 碼者（早期登記未做格式驗證留下的資料）只保留末四碼。
 *
 * 注意：這是「顯示層」的遮蔽。後端目前仍會把完整卡號回給前端，
 * 真正的治本是後端只回 bin6 + last4，詳見 docs\官網_20260910_卡號遮碼與明碼盤點.md
 */
export function maskCardNumber(cardNumber) {
    const digits = String(cardNumber || '').replace(/\D/g, '');
    if (!digits) return '';

    const keepHead = digits.length >= 11 ? 6 : 0;
    const keepTail = Math.min(4, digits.length);
    const maskLen = Math.max(0, digits.length - keepHead - keepTail);

    const masked =
        digits.slice(0, keepHead) +
        '*'.repeat(maskLen) +
        digits.slice(digits.length - keepTail);

    // 每四碼插一個空白（最後一組後面不加）
    return masked.replace(/.{4}(?=.)/g, '$& ');
}
